import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=67a62b9d&scoped=true&"
import script from "./ItemImage.vue?vue&type=script&lang=js&"
export * from "./ItemImage.vue?vue&type=script&lang=js&"
import style0 from "./ItemImage.vue?vue&type=style&index=0&id=67a62b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a62b9d",
  null
  
)

export default component.exports